import React from 'react'
import styles from './ProgressBanner.module.css'
import {
    MAIN_STEPS,
    PROGRESS,
    PROGRESS_LINE,
    STEP_GROUPS,
    STEP_ICONS,
    STEP_TEXT_MAP,
    STEPS,
} from '../../../../constants/progressBanner'
import { CurrentStepProps } from '../types'

const getProgressPercentageBySection = (currentStep: number): number => {
    const basicInfoSteps = {
        [STEPS.SEX]: PROGRESS.SECOND_SECTION,
        [STEPS.BIRTHDAY]: PROGRESS.SECOND_SECTION_2,
        [STEPS.PREFECTURE]: PROGRESS.SECOND_SECTION_3,
        [STEPS.FULL_NAME]: PROGRESS.SECOND_SECTION_4,
    }

    const contactSteps = {
        [STEPS.TEL]: PROGRESS.THIRD_SECTION,
        [STEPS.LOGIN_INFORMATION]: PROGRESS.THIRD_SECTION_2,
    }

    const careerSteps = {
        [STEPS.COMPANY_NAME]: PROGRESS.FOURTH_SECTION,
        [STEPS.EMPLOYMENT_STATUS]: PROGRESS.FOURTH_SECTION_2,
        [STEPS.ENROLLMENT_PERIOD]: PROGRESS.FOURTH_SECTION_3,
        [STEPS.CUISINE_GENRE]: PROGRESS.FOURTH_SECTION_4,
        [STEPS.JOB_CONTENT]: PROGRESS.FOURTH_SECTION_5,
        [STEPS.DETAILED_WORK_DETAILS]: PROGRESS.FOURTH_SECTION_6,
    }

    return (
        {
            ...basicInfoSteps,
            ...contactSteps,
            ...careerSteps,
        }[currentStep] || null
    )
}

const getProgressPercentage = (currentStep: number): number => {
    if (currentStep === STEPS.WORKING_STATUS) return PROGRESS.START
    if (currentStep === STEPS.EXPERIENCE_YEARS) return PROGRESS.FIRST_SECTION

    const sectionProgress = getProgressPercentageBySection(currentStep)
    if (sectionProgress !== null) return sectionProgress

    return PROGRESS.COMPLETE
}

const getCurrentGroup = (currentStep: number): number => {
    if (currentStep <= STEPS.EXPERIENCE_YEARS) return STEP_GROUPS.FIRST
    if (currentStep <= STEPS.FULL_NAME) return STEP_GROUPS.SECOND
    if (currentStep <= STEPS.LOGIN_INFORMATION) return STEP_GROUPS.THIRD
    if (currentStep <= STEPS.DETAILED_WORK_DETAILS) return STEP_GROUPS.FOURTH
    return STEP_GROUPS.FIFTH
}

const ProgressBanner = ({ currentStep }: CurrentStepProps) => {
    const progressPercentage = getProgressPercentage(currentStep)
    const currentGroup = getCurrentGroup(currentStep)
    const steps = Array.from({ length: MAIN_STEPS }, (_, i) => i)
    const isFirstStep = currentStep <= STEPS.WORKING_STATUS

    return (
        <div className={styles.stepperContainer}>
            <div className={styles.headerContainer}>
                <div className={styles.headerContent}>
                    {isFirstStep && (
                        <div className={styles.registerTitle}>
                            <img
                                src="/foodslaboEf/img/common/register_icon.png"
                                alt="登録アイコン"
                                className={styles.registerIcon}
                            />
                            無料登録して求人を確認する!
                        </div>
                    )}
                </div>
                <div className={styles.progressCardWrap}>
                    <div className={styles.progressCard}>
                        <div className={styles.progressTitle}>
                            {STEP_TEXT_MAP[currentStep]}
                        </div>
                        <div className={styles.progressBar}>
                            <div className={styles.progressBackground} />
                            <div
                                className={styles.progressLine}
                                style={{
                                    width: `calc(${progressPercentage}% - ${
                                        progressPercentage === PROGRESS.COMPLETE
                                            ? PROGRESS_LINE.COMPLETE_ADJUST
                                            : PROGRESS_LINE.DEFAULT_ADJUST
                                    }rem)`,
                                }}
                            />
                            <div className={styles.progressDots}>
                                {steps.map(step => (
                                    <div
                                        key={step}
                                        className={`
                                        ${styles.dot}
                                        ${step <= currentGroup ? styles.activeDot : ''}
                                        ${step === currentGroup ? styles.currentDot : ''}
                                    `}
                                    >
                                        {step === currentGroup &&
                                            STEP_ICONS[step] && (
                                                <img
                                                    src={STEP_ICONS[step]}
                                                    alt={`Step ${step + 1}`}
                                                    className={styles.stepIcon}
                                                />
                                            )}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ProgressBanner
